export const UPDATE_WORKSPACE_SETTINGS = "UPDATE_WORKSPACE_SETTINGS";
